import type { DragEvent, ReactNode } from 'react'
import { Etichetta } from '../../componenti/base.tsx'
import { IconaGraffetta } from '../../componenti/Icone.tsx'
import * as posta from '../../servizi/posta.ts'
import * as elenco from '../../servizi/posta-elenco.ts'
import { Bandierine, Etichette, attributiRiga } from './Segni.tsx'
import { EtichettaNonInviato } from './BozzeNellaCartella.tsx'
import { DoveTrovato } from './RicercaPosta.tsx'

/**
 * Una riga della vista per singoli messaggi (541; come la vista a elenco di Roundcube): mittente, o i
 * destinatari per la posta in uscita, oggetto, anteprima, data e dimensione. Bandierine, etichette e stato
 * sono della conversazione del messaggio, e toccando la riga si apre la conversazione su quel messaggio.
 */
export function RigaMessaggio({ m, attiva, scelta, casellaDetta, spunta, menu, trascina, apri }: {
  m: elenco.VoceMessaggio
  attiva: boolean
  scelta: boolean
  /** Nella vista unica: l'indirizzo della casella. */
  casellaDetta: string | null
  spunta: ReactNode
  menu: ReactNode
  /** Trascinamento sulle cartelle: null se qui non si sposta. */
  trascina: ((e: DragEvent) => void) | null
  apri: () => void
}) {
  const uscita = m.direzione === 'uscita'
  return (
    <div className={`posta-voce-riga${scelta ? ' selezionata' : ''}`} {...attributiRiga(m)}
         draggable={!!trascina} onDragStart={trascina ?? undefined}>
      {spunta}
      <button aria-current={attiva} className={`posta-voce${m.letto ? '' : ' non-letto'}${attiva ? ' attiva' : ''}`}
              data-thread={m.thread_id} onClick={apri}>
        <span className="capo">
          {!m.letto && <span className="pallino" role="img" aria-label="da leggere" />}
          <Bandierine segni={m} />
          <span className="mittenti">
            {uscita ? `a ${m.a.map(posta.nomeBreve).join(', ') || '—'}` : posta.nomeBreve(m.da) || '—'}
          </span>
          <span className="quando">{posta.dataElenco(m.data)}</span>
        </span>
        <span className="oggetto">
          {m.priorita_alta && <span className="posta-priorita" title="Priorità alta" aria-label="priorità alta">!</span>}
          {m.oggetto || '(senza oggetto)'}
        </span>
        <span className="anteprima">{m.anteprima}</span>
        {/* Con la ricerca: la cartella del messaggio. */}
        <DoveTrovato casella={null} cartelle={m.cartella === undefined ? null : [m.cartella]} archiviata={m.stato === 'archiviato'} />
        {m.etichette.length > 0 && <span className="coda"><Etichette etichette={m.etichette} massimo={3} /></span>}
        <span className="coda">
          {/* Non partito (3/11/2026): sta nelle «Bozze», con il motivo nella conversazione. */}
          {m.non_inviato && <EtichettaNonInviato errore={m.non_inviato.errore} />}
          {casellaDetta && <Etichetta>{casellaDetta}</Etichetta>}
          {m.ha_allegati && <IconaGraffetta />}
          {m.persona_id && <Etichetta tono="accento">scheda</Etichetta>}
          {m.provenienza === 'falsa_cidis' && <Etichetta tono="critico">falso CIDIS?</Etichetta>}
          {(m.provenienza === 'esterna' || m.provenienza === 'esterna_non_verificata') && (
            <Etichetta tono="attenzione">{m.provenienza === 'esterna' ? 'esterno' : 'esterno, non verificato'}</Etichetta>
          )}
          <span className="dimensione">{elenco.dimensioneLeggibile(m.dimensione)}</span>
        </span>
      </button>
      {menu}
    </div>
  )
}
